var _excluded = ["header", "align", "valign", "ellipsis", "maxLine", "maxLines", "stickyTop", "stickyStart", "stickyEnd", "noneStickyFirst", "offset", "width", "height", "rowSpan", "colSpan", "rowIndex", "colIndex", "className", "style", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { isNumber } from '@okee-uikit/react-utils';
import { useTableImplement, useTableCep } from '../implements/implement';
export function TableCell(props) {
  var _objectSpread2;

  var header = props.header,
      align = props.align,
      valign = props.valign,
      ellipsis = props.ellipsis,
      maxLine = props.maxLine,
      _props$maxLines = props.maxLines,
      maxLines = _props$maxLines === void 0 ? maxLine : _props$maxLines,
      stickyTop = props.stickyTop,
      stickyStart = props.stickyStart,
      stickyEnd = props.stickyEnd,
      noneStickyFirst = props.noneStickyFirst,
      offset = props.offset,
      width = props.width,
      height = props.height,
      rowSpan = props.rowSpan,
      colSpan = props.colSpan,
      rowIndex = props.rowIndex,
      colIndex = props.colIndex,
      className = props.className,
      style = props.style,
      children = props.children,
      attrs = _objectWithoutProperties(props, _excluded);

  var _useTableCep = useTableCep(),
      direction = _useTableCep.direction,
      elem = _useTableCep.elem;

  var rtl = direction === 'rtl';

  var _useTableImplement = useTableImplement(),
      isTable = _useTableImplement.isTable,
      TH = _useTableImplement.TH,
      TD = _useTableImplement.TD;

  var Cell = header && TH || TD;

  if (rowSpan === 0 || colSpan === 0) {
    return null;
  }

  var top = isNumber(stickyTop) && "".concat(stickyTop, "px") || undefined;
  var start = isNumber(stickyStart) && "".concat(stickyStart, "px") || undefined;
  var end = isNumber(stickyEnd) && "".concat(stickyEnd, "px") || undefined;
  var left = rtl ? end : start;
  var right = rtl ? start : end;
  var content = children;

  if (ellipsis) {
    if (maxLines > 1) {
      content = React.createElement("span", {
        className: elem('LineClamp'),
        style: {
          WebkitLineClamp: maxLines
        }
      }, content);
    } else {
      content = React.createElement("span", {
        className: elem('Ellipsis')
      }, content);
    }
  }

  return React.createElement(Cell, _objectSpread(_objectSpread({
    className: elem('Cell', {
      sticky: !!(top || start || end),
      stickyTop: !!top,
      stickyStart: !!start,
      stickyEnd: !!end,
      noneStickyFirst: noneStickyFirst,
      align: align,
      valign: valign,
      maxLines: maxLines
    }, className),
    style: _objectSpread((_objectSpread2 = {
      top: top,
      left: left,
      right: right
    }, _defineProperty(_objectSpread2, direction === 'rtl' && 'marginRight' || 'marginLeft', offset && isNumber(offset) && "".concat(offset, "px") || offset), _defineProperty(_objectSpread2, "width", width && isNumber(width) && "".concat(width, "px") || width), _defineProperty(_objectSpread2, "height", height && isNumber(height) && "".concat(height, "px") || height), _objectSpread2), style)
  }, attrs), {}, {
    scope: header,
    role: header === 'col' && 'columnheader' || header === 'row' && 'rowheader' || 'cell',
    rowSpan: rowSpan,
    colSpan: colSpan,
    "aria-rowspan": rowSpan,
    "aria-colspan": colSpan,
    "aria-rowindex": rowIndex,
    "aria-colindex": colIndex
  }), content);
}